<template>
  <div
    class="gs-posts-box-list-container"
    ref="postBoxListContainer"
    :class="{
      'unable-left-column-btn':
        pagination.prev === '' || pagination.prev === null,
      'unable-right-column-btn':
        pagination.next === '' || pagination.next === null,
      'with-navigation-bar': withNavigationBar,
      'with-navigation-pages': withNavigationPages,
    }"
  >
    <div
      v-if="withNavigationBar"
      class="column-nav-btn left-btn"
      @click="getPage(pagination.prev)"
    >
      <i
        aria-hidden="true"
        class="v-icon notranslate material-icons theme--light"
        >chevron_left</i
      >
    </div>
    <v-progress-linear
      :active="loading"
      :indeterminate="loading"
      absolute
      top
      :color="progress_lineal_color"
      height="100%"
    ></v-progress-linear>
    <div class="custom-post-box-container">
      <div
        :class="{ 'gs-loading': loading }"
        v-for="post in posts"
        :key="post.id"
        class="custom-post-box"
      >
        <post-box :post="post" />
      </div>
    </div>
    <div
      v-if="withNavigationBar"
      class="column-nav-btn right-btn"
      @click="getPage(pagination.next)"
    >
      <i
        aria-hidden="true"
        class="v-icon notranslate material-icons theme--light"
        >chevron_right</i
      >
    </div>
    <div v-if="withNavigationPages" class="pages-navigation">
      <ul>
        <li
          v-for="page in pagination.pages"
          class="li-page"
          :class="page.class"
          @click="getPage(page.link)"
        >
          {{ page.name }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from "axios/index";
import PostBox from "./PostBox";
import {
  VApp,
  VContainer,
  VLayout,
  VProgressLinear,
  VPagination,
} from "vuetify/lib";

export default {
  props: {
    progress_lineal_color: {
      type: String,
      default: "#72727233",
    },
    postType: {
      type: String,
      default: "cpt_sermon",
    },
    category: {
      type: String,
      default: null,
    },
    withNavigationBar: {
      type: Boolean,
      default: false,
    },
    withNavigationPages: {
      type: Boolean,
      default: false,
    },
    dataContent: {
      type: Object,
      default: () => {},
    },
    offSetScrollTo: {
      type: String,
      default: "0",
    },
  },
  name: "post-box-list",
  components: {
    "post-box": PostBox,
    VApp,
    VContainer,
    VLayout,
    VProgressLinear,
    VPagination,
  },
  mounted() {
    if (this.dataContent && this.dataContent.result) {
      this.posts = this.dataContent.result;
      this.pagination = this.dataContent.pagination;
    } else {
      this.getPage(1);
    }
  },
  data: function() {
    return {
      posts: [],
      pagination: {},
      loading: false,
      showNextButton: true,
      share: false,
    };
  },
  methods: {
    getUrl: function(page) {
      var url;
      var urlBase = "/wp-json/gsapi/v1/sermons/page/";
      if (this.postType === "post") {
        urlBase = "/wp-json/gsapi/v1/posts/page/";
      }
      if (_.isNumber(page)) {
        url = urlBase + page;
      } else if (typeof page === "string") {
        url = page;
      } else {
        url = page.link;
      }
      return url;
    },
    getPage: function(page) {
      if (!page) {
        return false;
      }
      this.loading = true;

      const params = {
        category: this.category,
      };
      axios
        .get(this.getUrl(page), { params })
        .then((response) => {
          this.loading = false;
          if (response.status == 200) {
            this.posts = response.data.result;
            this.pagination = response.data.pagination;
            let offSetScrollTo = this.offSetScrollTo;
            if (!isNaN(offSetScrollTo)) {
              offSetScrollTo = offSetScrollTo * 1;
            } else {
              offSetScrollTo = 0;
            }
            var cancelScroll = this.$scrollTo(
              this.$refs.postBoxListContainer,
              500,
              { offset: offSetScrollTo }
            );
          } else {
            console.log(response);
          }
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Montserrat|Roboto+Condensed&display=swap");

.custom-post-box-container {
  text-align: center;
}
.custom-post-box {
  display: inline-flex;
  text-align: left;
}

// iPhone 6, 7, & 8 in portrait & landscape
@media only screen and (min-device-width: 375px) and (max-device-width: 667px),
  only screen and (min-device-width: 360px) and (max-device-width: 740px) {
  .custom-post-box {
    width: 100%;
  }
  .gs-post-card.xs {
    margin: 0px 0px 20px 0px;
  }
}

/* Grafica de Post modo lista */
.gs-posts-box-list-container {
  &.with-navigation-bar {
    padding: 0px 41px !important;
  }

  position: relative;
  font-family: Roboto, sans-serif;
  color: #747474;
  min-height: 472px;

  .layout {
    justify-content: center !important;
  }

  &.unable-left-column-btn {
    padding-left: 0px !important;
    .column-nav-btn.left-btn {
      display: none;
    }
  }
  &.unable-right-column-btn {
    padding-right: 0px !important;
    .column-nav-btn.right-btn {
      display: none;
    }
  }

  .v-btn--fab.v-size--default {
    height: 35px;
    width: 35px;
  }
  .gs-footer-post-footer {
    width: 100%;
    position: absolute;
    bottom: 0px;
    .gs-hr {
      padding: 0 14px;
      hr {
        width: 100%;
        height: 1px;
        background-color: #e0e0e0;
        border: none;
      }
    }
  }

  .theme--light.v-pagination .v-pagination__item--active {
    color: #ffffff !important;
    background-color: #a3a3a3;
  }
  .theme--light.v-pagination .v-pagination__item {
    color: rgba(112, 112, 112, 0.87);
  }
  .v-pagination {
    margin-top: 23px;
    .theme--light.v-icon {
      color: rgb(181, 181, 181);
    }
  }
}
.gs-loading {
  opacity: 0.5;
}

.column-nav-btn {
  &.right-btn {
    right: 0;
  }
  &.left-btn {
    left: 0;
  }
  &:hover {
    background: #00000014;
  }
  cursor: pointer;
  position: absolute;
  top: 5px;
  bottom: 5px;
  width: 37px;
  background: #0000000a;
  vertical-align: middle;
  display: flex;
  text-align: center;
  i {
    width: 100%;
    font-size: 48px !important;
    opacity: 0.2;
  }
}

.gs-type-box {
  .pages-navigation {
    padding: 38px 35px;
    ul {
      text-align: center;
      list-style: none;
      li.dots {
        display: inline;
        margin-right: 20px;
        font-size: 20px;
        &:after {
          content: "...";
          width: 10px;
          height: 10px;
          border-radius: 50%;
        }
      }
      li:not(.dots) {
        display: inline;
        padding: 10px 15px;
        background: #959595;
        margin-right: 21px;
        color: white;
        border-radius: 30px;
        font-weight: bold;
        font-size: 16px;
        &:not(.current) {
          cursor: pointer;
          background: rgba(189, 189, 189, 0.64);
          color: #797979;
          line-height: 45px;
        }
      }
    }
  }
}
</style>
